import React from 'react';

import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';

import webinarData from 'marketing-website/configs/pages/resources/webinarData.js';
import InfoBlock from 'marketing-website/components/modules/infoBlock/index.js';

import HeadingCopy from 'marketing-website/components/modules/HeadingCopy/HeadingCopy.js';

export default function WebinarsBlock() {
  return (
    <div>
      <HeadingCopy
        title="What's on"
        subheading="Catch up on our latest webinars and keep an eye out for upcoming events for you to join"
      />
      <Grid columns={12}>
        {webinarData.map(item => (
          <GridItem columnSpan={12} columnSpanM={3} columnSpanS={6}>
            <InfoBlock key={item.name} {...item} />
          </GridItem>
        ))}
      </Grid>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/resources/_WebinarsBlock.js